import moment from 'moment';

// LiveAgent files are as separate messages,
// but they should be under one message
export const mergeLiveAgentFiles = (data, docs) => {
  let result = data;
  let messages = result.chatMessages;
  let i = 1;

  if (messages.length > 1) {
    while (i < messages.length) {
      const prevMsg = messages[i - 1];
      const msg = messages[i];
      if (msg.filename) {
        let fileData;
        if (msg.fileStoredId) {
          fileData = docs.find(f => f.url.includes(msg.fileStoredId));
        } else {
          fileData = docs.find(f => f.name === msg.filename);
        }
        if (
          !prevMsg.filename &&
          msg.direction === prevMsg.direction &&
          msg.timeat.hour === prevMsg.timeat.hour &&
          msg.timeat.minute === prevMsg.timeat.minute &&
          msg.timeat.second === prevMsg.timeat.second
        ) {
          if (!prevMsg.files) {
            prevMsg.files = [];
          }
          prevMsg.files.push({
            url: fileData.url,
            name: fileData.name,
            fileName: fileData.fileName
          });
          messages.splice(i, 1);
        } else {
          if (msg.body === `<file attachment: ${msg.filename} >`) {
            msg.body = '';
          }
          msg.files = [];
          msg.files.push({
            url: fileData.url,
            name: fileData.name,
            fileName: fileData.fileName
          });
          i++;
        }
      } else {
        i++;
      }
    }
  }
  result.chatMessages = messages;
  return result;
};

// format from UTC time "2021-10-06T10:36:52Z" -> to header time "06. Oktober 2021 - 12:36"
export const formatNotificationTime = dateTime => {
  const tzOffset = new Date().getTimezoneOffset();
  let time = moment.utc(dateTime);

  time = time.add(-tzOffset, 'minute');
  return time.format('DD. MMMM YYYY - HH:mm');
};

export const formatLiveAgentTime = (apiBaseDate, apiDateTime = apiBaseDate) => {
  const tzOffset = new Date().getTimezoneOffset();
  let time = moment.utc({
    y: apiBaseDate.year,
    M: apiBaseDate.monthValue - 1,
    d: apiBaseDate.dayOfMonth,
    h: apiDateTime.hour,
    m: apiDateTime.minute,
    s: apiDateTime.second
  });

  time = time.add(-tzOffset, 'minute');
  return time.format('HH:mm');
};
